import { render, staticRenderFns } from "./EventWithSessionOptionsAndDietaryRestrictions.vue?vue&type=template&id=6ee3a796&scoped=true"
import script from "./EventWithSessionOptionsAndDietaryRestrictions.vue?vue&type=script&lang=js"
export * from "./EventWithSessionOptionsAndDietaryRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3a796",
  null
  
)

export default component.exports